import { useParams } from "@tanstack/react-router";
import { useMemo } from "react";
import { Bar, BarChart, ResponsiveContainer, XAxis, YAxis } from "recharts";
import { useTenantCdrSummaryQuery } from "@/hooks/queries/use-tenant-cdr-summary";

const SUMMARY_LOOKBACK_DAYS = 7;
const BAR_CORNER_RADIUS = 4;
const BAR_RADIUS: [number, number, number, number] = [
  BAR_CORNER_RADIUS,
  BAR_CORNER_RADIUS,
  0,
  0,
];

export function Overview() {
  const params = useParams({ from: "/_app/$tenantId/" });
  const tenantId = params.tenantId;
  const { data: summary } = useTenantCdrSummaryQuery(
    tenantId,
    SUMMARY_LOOKBACK_DAYS,
    {
      enabled: Boolean(tenantId),
    }
  );

  const chartData = useMemo(() => {
    if (!summary?.daily) return [];
    return summary.daily.map(({ date, count }) => {
      const parsedDate = new Date(date);
      const name = parsedDate.toLocaleDateString("en-US", {
        weekday: "short",
      });
      return {
        name,
        total: count,
      };
    });
  }, [summary?.daily]);

  return (
    <ResponsiveContainer height={300} width="100%">
      <BarChart data={chartData}>
        <XAxis
          axisLine={false}
          dataKey="name"
          fontSize={12}
          stroke="#888888"
          tickLine={false}
        />
        <YAxis
          axisLine={false}
          fontSize={12}
          stroke="#888888"
          tickFormatter={(value) => `${value}`}
          tickLine={false}
        />
        <Bar
          className="fill-primary"
          dataKey="total"
          fill="currentColor"
          radius={BAR_RADIUS}
        />
      </BarChart>
    </ResponsiveContainer>
  );
}
